export const REVIEW_SHOW_TABS = ['general'] as const;
export type ReviewShowTab = (typeof REVIEW_SHOW_TABS)[number];
export const REVIEW_DEFAULT_TAB: ReviewShowTab = 'general';
